import React from "react";
import InternalOrderView from "../../Internal/OrderView"

class VenueOrderView extends React.Component {
  render() {
    return (<div className="OrderView">
        <InternalOrderView
        {...this.props}
        match={this.props.computedMatch} // required because Venue uses ProtectedRoute and Internal uses Route
        dataSource={"venue_admin/orders"}
        showFees={false} />
        </div>);
}

}

export default VenueOrderView
